import i18n from '../../../../../i18n'
import { ClothSizeCt } from '../../../../../model/enums/enums'

export const clothSize = [
    { value: ClothSizeCt.XXS, label: 'XXS' },
    { value: ClothSizeCt.XS, label: 'XS' },
    { value: ClothSizeCt.S, label: 'S' },
    { value: ClothSizeCt.M, label: 'M' },
    { value: ClothSizeCt.L, label: 'L' },
    { value: ClothSizeCt.XL, label: 'XL' },
    { value: ClothSizeCt.XXL, label: 'XXL' },
    { value: ClothSizeCt.XXXL, label: 'XXXL' },
    { value: null, label: i18n.t<string>('core.statistic.not_specified') }
]
